/* eslint-disable */

export const LOCALE_CONSTANTS = {
    GET_CURRENT_LOCALE: 'GET_CURRENT_LOCALE',
};
